import React, { useEffect, useState } from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Box, Button, Container } from '@mui/material'
import logo from './images/logo.png'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { makePostRequest } from 'utils/api'
import CircularProgress from '@mui/material/CircularProgress'
import ComboBox from './ComboBox'

export default function OpenBank() {
  let navigate = useNavigate()
  const location = useLocation()
  let params = useParams()
  const [confirm, setConfirm] = useState(true)
  const [selectedAcc, setSelectedAcc] = useState(false)
  const [accounts, setAccounts] = useState([])
  const [accountsList, setAccountsList] = useState([])

  useEffect(() => {
    verifyAccount()
  }, [])
  const handleConnect = async () => {
    let acc = accounts.find((x) => x.id === selectedAcc)
    const response = await makePostRequest(
      '/api/Finance/open-bank/',
      {
        ...acc,
        commond: 'add-account',
      },
      {},
      true,
    )
    if (response.status === 200) {
      navigate('/MesComptes')
    }
  }
  const verifyAccount = async () => {
    const queryParams = new URLSearchParams(location.search)
    const response = await makePostRequest(
      '/api/Finance/open-bank/',
      {
        code: queryParams.get('code'),
        credentials_id: queryParams.get('credentials_id'),
        user_id: queryParams.get('state'),
      },
      {},
      true,
    )
    if (response.status === 200) {
      setConfirm(false)
      let listac = []
      response.data?.accounts &&
        response.data?.accounts.forEach((ele) => {
          listac.push({ id: ele.id, label: `${ele.name} - (${ele.type})`, value: ele.id })
        })
      setAccountsList(listac)
      setAccounts(response.data?.accounts)
    } else {
      //   navigate('/')
    }
  }
  console.log(accounts)
  const handleAutocomplete = (name, val) => {
    if (val) {
      setSelectedAcc(val?.id)
    } else {
      setSelectedAcc(false)
    }
  }
  return (
    // <ThemeProvider theme={defaultTheme}>
    <Container component="main" maxWidth="xs">
      {/* <CssBaseline /> */}

      <Box
        sx={{
          pt: 15,
          pb: 30,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: 'white',
        }}
      >
        {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar> */}
        <Box sx={{ mb: 5 }}>
          <img src={logo} alt="" />{' '}
        </Box>
        {confirm ? (
          <Box sx={{ display: 'flex', mt: 10 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={'column'}
            alignItems={'center'}
            mt={4}
          >
            <Box
              sx={{
                mb: 5,
                width: '444px',
                padding: '10px',
                borderRadius: '10px',
                bgcolor: 'white',
              }}
            >
              <ComboBox
                handleAutoComplete={handleAutocomplete}
                label="Select Account"
                data={accountsList}
                name="acType"
              />
              <Button
                onClick={handleConnect}
                disabled={selectedAcc === false ? true : false}
                sx={{ mt: 5 }}
                variant="contained"
              >
                Se connecter
              </Button>
            </Box>
          </Box>
        )}
      </Box>
      {/* <Copyright sx={{ mt: 5 }} /> */}
    </Container>
    // </ThemeProvider>
  )
}
